import { api } from './api';

export interface Fornecedor {
  id: number;
  codPessoa: number;
  ativo: number;
  cnpj: string;
  codEndereco: number;
  cpf: string;
  email: string;
  nome: string;
  rg: string;
  telefone1: string;
  telefone2: string;
  bairro: string;
  cep: string;
  cidade: string;
  estado: string;
  logradouro: string;
  numero: string;
}

export interface FornecedorRequest {
  id?: number;
  codPessoa: number;
  ativo: number;
  cnpj: string;
  codEndereco: number;
  cpf: string;
  email: string;
  nome: string;
  rg: string;
  telefone1: string;
  telefone2: string;
  bairro: string;
  cep: string;
  cidade: string;
  estado: string;
  logradouro: string;
  numero: string;
}

export const fornecedorService = {
  getAll: async (): Promise<Fornecedor[]> => {
    const response = await api.get('/api/Fornecedor/GetAll');
    return response.data;
  },

  getById: async (id: number): Promise<Fornecedor> => {
    const response = await api.get(`/api/Fornecedor/GetById?id=${id}`);
    return response.data;
  },

  save: async (data: FornecedorRequest): Promise<void> => {
    if (data.id === 0 || !data.id) {
      await api.post('/api/Fornecedor/Salvar', data);
    } else {
      await api.post('/api/Fornecedor/Alterar', data);
    }
  }
};
